import { useRoot } from './hooks/useRoot';
import { MissionHero } from './components/hero';
import { MissionSummaryChapter } from './components/summary-chapters';
import { Boxes } from './components/boxes';
import { DownloadArea } from './components/download-area';
import { TrainingArea } from './components/training-area';
import { Chapters } from './components/chapters';
import { ErrorScreen } from '../../Error';
import { LoadingContainer } from '../shared/components/loading-container';
import { Suspense } from 'react';
import { ConsoleCJ } from '../../Error/Console';
import Divider from '@/components/Divider';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';

const MissionDetailing = () => {
  const { mission, errors } = useRoot();

  if (!mission) {
    return <></>;
  }

  if (errors.length > 0) {
    ConsoleCJ.customError('MissionDetailingScreen', {
      ...errors,
    });
    return <ErrorScreen />;
  }

  return (
    <Container className="!mt-sh-60">
      <div className=" col-span-12 lg:col-start-11 lg:col-end-3 ">
        <PageHeader title={'Mission'} type="none" />
        <MissionHero />
        <MissionSummaryChapter />
        <Divider />
        <p className="font-cadiz text-sh-xs">{mission.description}</p>
        <Divider />
        <div className="flex flex-col gap-4">
          <Boxes />
          <DownloadArea />
        </div>
        <TrainingArea />
        <Divider />
        <Chapters />
      </div>
    </Container>
  );
};

export const MissionDetailingScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading mission..." />}>
      <MissionDetailing />
    </Suspense>
  );
};
